import type { PermissionsInfo } from '@/ccpv2/types';

export const createPermissionsInfoDefaults = () => {
  const res: PermissionsInfo = {
    can_approve_group: false,
    can_view_comments: false,
    can_create_comments: false,
    can_view_budgets: false,
    can_view_change_history: false,
    can_download_reward_letters: false,
    can_send_reward_letters: false,
    can_export_data: false,
    can_copy_or_sync_employees: false,
    is_active: false,
    is_approved: false,
    allow_inactive_group_view: false,
    name: '',
    planning_group_name: '',
    role_name: '',
  };

  return res;
};

export const createPermissionsInfoAdmin = () => {
  const res: PermissionsInfo = {
    can_approve_group: true,
    can_view_comments: true,
    can_create_comments: true,
    can_view_budgets: true,
    can_view_change_history: true,
    can_download_reward_letters: true,
    can_send_reward_letters: true,
    can_export_data: true,
    can_copy_or_sync_employees: true,
    is_active: true,
    is_approved: true,
    allow_inactive_group_view: true,
    name: '',
    planning_group_name: '',
    role_name: '',
  };

  return res;
};
